module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"menu":{"save":"画像を保存"}},"en":{"menu":{"save":"Save image"}}}')
  delete Component.options._Ctor
}
